<!--
<section class="title-bar content-padding first-item">
  <div class="wrapper nowrap">
    <h2 class="title-heading">{{form?.expert?.id ? "Modifica" : "Nuovo"}} Valet</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <button class="btn btn-red vertical align-items-center" (click)="delete()" *ngIf="!!form?.expert?.id && groups.includes('admin')">
          Elimina<i class="ml-30 fas fa-trash"></i>
        </button>
      </span>
    </div>
  </div>
</section>

<app-expert-form></app-expert-form>
-->

<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">{{form?.expert?.id ? "Modifica" : "Nuovo"}} VALET</a>
      </label>
    </div>

    <div class="button-wrapper">
      <button class="btn btn-red vertical align-items-center" (click)="delete()" *ngIf="!!form?.expert?.id && groups.includes('admin')">
        Elimina<i class="ml-10 fas fa-trash"></i>
      </button>
    </div>

    <app-expert-form></app-expert-form>
  </div>
</section>
